// L'avatar, côté React.
//
// L'ancienne version rendait une chaîne de HTML ; ici c'est un vrai élément.
// Le nom passe par les props, donc React l'échappe — la faille d'injection
// n'existe plus, elle est devenue impossible à écrire.

import Icone from "./Icone.jsx";

/**
 * @param {object} p
 * @param {object} p.membre   { nom, photo }
 * @param {number} p.taille   en pixels
 * @param {boolean} p.anneau  cercle bleu : le membre a un statut en cours
 */
export default function Avatar({ membre, taille = 40, anneau = false }) {
  const nom = membre?.nom || "Membre";
  const style = { width: taille, height: taille };
  const classe = `avatar${anneau ? " avatar--statut" : ""}`;

  if (membre?.photo) {
    return <img className={classe} style={style} src={membre.photo} alt={nom} loading="lazy" />;
  }
  // sans photo : la silhouette grise, comme la photo par défaut de Facebook
  return (
    <span className={`${classe} avatar--vide`} style={style} role="img" aria-label={nom}>
      <Icone nom="avatarVide" taille={taille} plein />
    </span>
  );
}
